import React, { Suspense } from 'react';

import {
  InteractionAccordionPanelProps,
  InteractionModalComponentProps,
} from '$/components/Interactions/types';
import Form from '$/components/ui/Form';

const QuizSettings = React.lazy(() => import('./QuizSettings'));

export const useQuizSettings: (
  props: InteractionModalComponentProps
) => InteractionAccordionPanelProps[] = (props) => {
  return [
    {
      key: 'Settings',
      active: true,
      title: { content: <Form.AccordionTitle title={'Settings'} /> },
      content: {
        content: (
          <Suspense>
            <QuizSettings {...props} />
          </Suspense>
        ),
      },
    },
  ];
};
